import createImageIcon from './createImageIcon';
import path from './time.svg';

export default createImageIcon({displayName: 'TimeIcon', path});



// WEBPACK FOOTER //
// ./src/common/components/icons/TimeIcon.js